import React, { useEffect, useState } from 'react'
import { FormProvider, useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Tab } from 'semantic-ui-react'
import MilkMoneyAccountingService from '~/api/services/milkMoneyAccounting'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import { StyledMenuItem } from '~/pages/Dairy/CloudStorage/style'
import Generally from './Generally'
import BankDetails from './BankDetails'
import { handleErrors } from '~/utils/helpers'

const MilkMoney: React.FC = () => {
  const { t } = useTranslation()

  const [isBusy, setIsBusy] = useState(false)
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const methods = useForm({
    mode: 'onSubmit'
  })

  const accounts = useWatch({ control: methods.control, name: 'accounts' })
  const isSubmitted = methods.formState.isSubmitted

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await MilkMoneyAccountingService.getMilkMoneyToursSettings()
      methods.reset(response.data)
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  function renderActions() {
    return <El.PageHeaderActionButton>{t('Update')}</El.PageHeaderActionButton>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      data.conversionFactor = data?.conversionFactor?.replace(',', '.')
      await MilkMoneyAccountingService.updateMilkMoneyToursSettings(data)
      notify(t('Successfully updated milk money settings'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function getMenuItem(label: string, hasError: boolean) {
    return (
      <StyledMenuItem className='tab-item'>
        <div className={hasError ? 'error' : ''}>{label}</div>
      </StyledMenuItem>
    )
  }

  function renderTabs() {
    const errors = methods.formState.errors
    const generallyHasError = isSubmitted && (('ftpImportInterval' in errors) || ('conversionFactor' in errors))
    const accountsEmpty = isSubmitted && (!accounts || accounts.length === 0)
    const panes = [
      {
        menuItem: getMenuItem(t('Generally'), generallyHasError),
        render: () => <Generally />
      },
      {
        menuItem: getMenuItem(t('Bank Details'), accountsEmpty),
        render: () => <BankDetails />
      }
    ]
    return <Tab
      menu={{ secondary: true, pointing: true }}
      activeIndex={activeTabIndex}
      panes={panes}
      onTabChange={(_, data) => setActiveTabIndex(data.activeIndex as number)}
    />
  }

  return <Layout
    isBusy={isBusy}
    title={t('Milk money settings')}
    actions={renderActions()}
    segmented
    onSubmit={methods.handleSubmit(onSubmit)}
  >
    <FormProvider {...methods}>
      {renderTabs()}
    </FormProvider>
  </Layout>
}
export default MilkMoney